var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "search-form-outer dark-layout",
      attrs: { action: "/search", method: "get", role: "search" },
    },
    [
      _c("h3", { staticClass: "search-title" }, [_vm._v("Search:")]),
      _vm._v(" "),
      _c("div", { staticClass: "search-form dark-layout" }, [
        _c(
          "label",
          { staticClass: "visually-hidden", attrs: { for: "MiniSearch" } },
          [_vm._v("\n      Search\n    ")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query",
            },
          ],
          ref: "input",
          staticClass: "instant-search__input",
          attrs: {
            type: "search",
            name: "q",
            id: "MiniSearch",
            placeholder: "Search",
            autocomplete: "off",
          },
          domProps: { value: _vm.query },
          on: {
            keyup: function ($event) {
              return _vm.search($event)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.query = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _vm.all_empty == false
        ? _c("div", { staticClass: "instant-search__results" }, [
            _vm.products.length
              ? _c("section", { staticClass: "results-group products" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "result-group__ul" },
                    _vm._l(_vm.products, function (product, idx) {
                      return _c(
                        "li",
                        { key: idx, staticClass: "result-group__li" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "product-item__link result-product",
                              attrs: {
                                href:
                                  "/collections/" +
                                  _vm.handle +
                                  "/products/" +
                                  product.handle,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "product-item__image-wrapper lazy-container",
                                  staticStyle: { "--aspect-ratio": "4/5" },
                                },
                                [
                                  _c("img", {
                                    staticClass: "lazyload",
                                    attrs: {
                                      "data-sizes": "auto",
                                      "data-src": product.images["1"],
                                      alt: product.title,
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "product-item__details-wrapper",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "product-item__title" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(product.title) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.suggestions.length
              ? _c("section", { staticClass: "results-group suggestions" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "result-group__ul" },
                    _vm._l(_vm.suggestions, function (suggestion, idx) {
                      return _c(
                        "li",
                        {
                          key: idx,
                          staticClass: "result-group__li",
                          on: {
                            click: function ($event) {
                              return _vm.searchSuggestion(suggestion)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(suggestion) + "\n        "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pages.length
              ? _c("section", { staticClass: "results-group pages" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "result-group__ul" },
                    _vm._l(_vm.pages, function (page, idx) {
                      return _c(
                        "li",
                        { key: idx, staticClass: "result-group__li" },
                        [
                          _c("a", { attrs: { href: page.url } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(page.title) +
                                "\n          "
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.products_found,
                    expression: "products_found",
                  },
                ],
                staticClass: "results-all-products",
                attrs: { type: "submit" },
              },
              [
                _vm._v(
                  "\n      View All " +
                    _vm._s(_vm.products_found) +
                    " Products >\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "btn", attrs: { type: "submit" } }, [
      _c("span", { staticClass: "icon-fallback-text" }, [_vm._v("Submit")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "results-group__header" }, [
      _c("span", [_vm._v("Products")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "results-group__header" }, [
      _c("span", [_vm._v("Suggestions")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "results-group__header" }, [
      _c("span", [_vm._v("Pages")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }